module.exports = __webpack_public_path__ + "img/img_logo.09ee88ec.png";